import { useCallback } from "react";
import { makeStyles } from "tss-react/mui";
import { Button, Grid, Paper, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import SimpleTable from "../../../common/tables/SimpleTable";
import { useDispatch } from "../providers/DispatchProvider";
import useDispatchColumns from "../common/useDispatchColumns";

const useStyles = makeStyles()(
  (theme) => ({
    surface: {
      borderRadius: theme.spacing(2),
      "& .MuiDataGrid-toolbarContainer": {
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(2),
        paddingBottom: 0,
        paddingTop: theme.spacing(3)
      }
    },

  })
);

const DEFAULT_SETTINGS_TABLE = {
  visibleColumns: {
    created: false,
    type: false,
    cause: false,
    registration: false,
    description: false,
    details: false,
    eta: false,
  },
}

export default function DesktopRecentlyCompletedView() {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { showLoading, completedTasks, completedTasks24H } = useDispatch();
  const onRowClick = useCallback(params => navigate(`./${params.id}`), [navigate]);
  const columns = useDispatchColumns();

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="body" color="textSecondary">
          {completedTasks24H.length} {t("dispatch:recentlyCompleted:last24h")} ({completedTasks.length} {t("common:today")})
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Paper className={classes.surface}>
          <SimpleTable
            tableId="completed_tasks_v2"
            loading={showLoading}
            rows={completedTasks24H}
            columns={columns}
            onRowClick={onRowClick}
            emptyStateTitle={t("dispatch:recentlyCompleted:emptyStateTitle")}
            emptyStateDescription={t("dispatch:recentlyCompleted:emptyStateDescription")}
            defaultSettings={DEFAULT_SETTINGS_TABLE}
            disablePaging
          />
        </Paper>
      </Grid>


      <Grid item xs={12}>
        <Stack alignItems="center" justifyContent="center" spacing={1}>
          <Typography variant="body2" color="textSecondary">
            {t("dispatch:recentlyCompleted:archive")}
          </Typography>
          <Button variant="contained" color="inherit" size="small" onClick={() => navigate("/tasks")}>
            {t("dispatch:recentlyCompleted:archiveButton")}
          </Button>
        </Stack>
      </Grid>


    </>
  );
}